import * as React from 'react';
import { Dispatch } from 'react-redux';
import { DriveItemInfo } from '../../containers/DriveItemList/reducer';
import { StoreState } from '../../reducers';
import { PageOverlay } from '../PageOverlay/styles';
import { closeContextualMenu } from '../../containers/DriveItemList/actions';
import { DropdownContainer, DropDownList, SpinnerContainer } from './styles';
import Item from '../../containers/ContextualMenu/Item';
import { ContextualMenuItemType } from './constants';
import DriveItemUtils from '../../utils/driveItem';
import { Spinner } from '../Spinner/styles';

interface ContextualMenuProps {
	dispatch: Dispatch<StoreState>;
	isOpened: boolean;
	isLocked: boolean;
	driveItem: DriveItemInfo | undefined;
	buttons: ContextualMenuButtons;
	tagClasses: string[] | undefined;
}

type ContextualMenuButtons = { [K in ContextualMenuItemType]: boolean; };

class ContextualMenu extends React.Component<ContextualMenuProps, never> {

	constructor(props: ContextualMenuProps) {
		super(props);
	}

	onOverlayClick() {
		const { dispatch } = this.props;

		dispatch(closeContextualMenu());
	}

	getItemsType(): ContextualMenuItemType[] {
		const { buttons } = this.props;
		let itemsType: ContextualMenuItemType[] = [];

		Object.keys(ContextualMenuItemType)
			.forEach(key => {
				const contextualMenuItemType = ContextualMenuItemType[key];
				if (buttons[key]) {
					itemsType.push(contextualMenuItemType);
				}
			})
		;

		return itemsType;
	}

	renderItems(): JSX.Element[] {
		const itemsData = this.getItemsType();

		return itemsData.map(itemType => (
			<Item type={itemType} key={itemType}/>
		));
	}

	render() {
		const { isOpened, isLocked, driveItem, tagClasses} = this.props;
		const className = DriveItemUtils.getItemClassName('ContextualMenu', driveItem, tagClasses);

		return (
			<>
				<PageOverlay isOpen={isOpened} onClick={() => this.onOverlayClick()}/>
				{isOpened &&
					<DropdownContainer className={className}>
						{isLocked && <SpinnerContainer><Spinner/></SpinnerContainer>}
						<DropDownList>
							{this.renderItems()}
						</DropDownList>
					</DropdownContainer>
				}
			</>
		);
	}
}

export default ContextualMenu;
export {
	ContextualMenuButtons,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/index.tsx